import React from 'react';
import { motion } from 'framer-motion';

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 }
};

const Videos = () => {
  return (
    <section id="videos" className="py-16 bg-surface-light dark:bg-surface-dark border-b border-opacity-20 border-gray-400 dark:border-gray-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

        <motion.h2
          className="text-4xl font-extrabold text-text-primary-light dark:text-text-primary-dark mb-12 font-poppins"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false }}
          transition={{ duration: 0.6 }}
        >
          Videos
        </motion.h2>

        <motion.div
          className="mb-16"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h3 className="text-2xl font-semibold text-text-primary-light dark:text-text-primary-dark mb-4 font-poppins">
            Project Demonstration Video
          </h3>
          <video
            controls
            className="w-full max-w-4xl mx-auto rounded-2xl shadow-xl border border-gray-200 dark:border-gray-600"
          >
            <source src="/intro-video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </motion.div>

        <motion.div
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <h3 className="text-2xl font-semibold text-text-primary-light dark:text-text-primary-dark mb-4 font-poppins">
            Sample Output Video
          </h3>
          <video
            controls
            className="w-full max-w-4xl mx-auto rounded-2xl shadow-xl border border-gray-200 dark:border-gray-600"
          >
            <source src="/output-sample.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </motion.div>

      </div>
    </section>
  );
};

export default Videos;